export enum InsuranceType {
    GeneralLiability = 0,
    BuildersRisk = 1,
    WorkmansComp = 2,
    Dwelling = 3,
    Flood = 4,
    Other = 5,
}
